module.exports = __webpack_public_path__ + "img/Cuban Sandwich-Soy Gardien.a1149dfe.jpg";